import { ShowsFrequencyInitData, ShowsFrequencyPeriodPreset } from '../typings/showsFrequency';

export const INIT_SHOWS_FREQUENCY_EDITORS = 'INIT_SHOWS_FREQUENCY_EDITORS';
export type INIT_SHOWS_FREQUENCY_EDITORS = typeof INIT_SHOWS_FREQUENCY_EDITORS;

export interface InitShowsFrequencyEditors {
    type: INIT_SHOWS_FREQUENCY_EDITORS;
    initData: ShowsFrequencyInitData[];
}

export function initShowsFrequencyEditors(initData: ShowsFrequencyInitData[]): InitShowsFrequencyEditors {
    return {
        type: INIT_SHOWS_FREQUENCY_EDITORS,
        initData
    };
}

export const TOGGLE_SHOWS_FREQUENCY = 'TOGGLE_SHOWS_FREQUENCY';
export type TOGGLE_SHOWS_FREQUENCY = typeof TOGGLE_SHOWS_FREQUENCY;

export interface ToggleShowsFrequency {
    type: TOGGLE_SHOWS_FREQUENCY;
    editorId: string;
}

export function toggleShowsFrequency(editorId: string): ToggleShowsFrequency {
    return {
        type: TOGGLE_SHOWS_FREQUENCY,
        editorId
    };
}

export const CHANGE_SHOWS_FREQUENCY_LIMIT = 'CHANGE_SHOWS_FREQUENCY_LIMIT';
export type CHANGE_SHOWS_FREQUENCY_LIMIT = typeof CHANGE_SHOWS_FREQUENCY_LIMIT;

export interface ChangeShowsFrequencyLimit {
    type: CHANGE_SHOWS_FREQUENCY_LIMIT;
    editorId: string;
    showsLimit: string;
}

export function changeShowsFrequencyLimit(editorId: string, showsLimit: string): ChangeShowsFrequencyLimit {
    return {
        type: CHANGE_SHOWS_FREQUENCY_LIMIT,
        editorId,
        showsLimit
    };
}

export const CHANGE_SHOWS_FREQUENCY_PERIOD_PRESET = 'CHANGE_SHOWS_FREQUENCY_PERIOD_PRESET';
export type CHANGE_SHOWS_FREQUENCY_PERIOD_PRESET = typeof CHANGE_SHOWS_FREQUENCY_PERIOD_PRESET;

export interface ChangeShowsFrequencyPeriodPreset {
    type: CHANGE_SHOWS_FREQUENCY_PERIOD_PRESET;
    editorId: string;
    periodPreset: ShowsFrequencyPeriodPreset;
}

export function changeShowsFrequencyPeriodPreset(
    editorId: string,
    periodPreset: ShowsFrequencyPeriodPreset
): ChangeShowsFrequencyPeriodPreset {
    return {
        type: CHANGE_SHOWS_FREQUENCY_PERIOD_PRESET,
        editorId,
        periodPreset
    };
}

export const CHANGE_SHOWS_FREQUENCY_CUSTOM_PERIOD = 'CHANGE_SHOWS_FREQUENCY_CUSTOM_PERIOD';
export type CHANGE_SHOWS_FREQUENCY_CUSTOM_PERIOD = typeof CHANGE_SHOWS_FREQUENCY_CUSTOM_PERIOD;

export interface ChangeShowsFrequencyCustomPeriod {
    type: CHANGE_SHOWS_FREQUENCY_CUSTOM_PERIOD;
    editorId: string;
    customPeriod: string;
}

export function changeShowsFrequencyCustomPeriod(
    editorId: string,
    customPeriod: string
): ChangeShowsFrequencyCustomPeriod {
    return {
        type: CHANGE_SHOWS_FREQUENCY_CUSTOM_PERIOD,
        editorId,
        customPeriod
    };
}

export const VALIDATE_SHOWS_FREQUENCY_LIMIT = 'VALIDATE_SHOWS_FREQUENCY_LIMIT';
export type VALIDATE_SHOWS_FREQUENCY_LIMIT = typeof VALIDATE_SHOWS_FREQUENCY_LIMIT;

export interface ValidateShowsFrequencyLimit {
    type: VALIDATE_SHOWS_FREQUENCY_LIMIT;
    editorId: string;
}

export function validateShowsFrequencyLimit(editorId: string): ValidateShowsFrequencyLimit {
    return {
        type: VALIDATE_SHOWS_FREQUENCY_LIMIT,
        editorId
    };
}

export const VALIDATE_SHOWS_FREQUENCY_CUSTOM_PERIOD = 'VALIDATE_SHOWS_FREQUENCY_CUSTOM_PERIOD';
export type VALIDATE_SHOWS_FREQUENCY_CUSTOM_PERIOD = typeof VALIDATE_SHOWS_FREQUENCY_CUSTOM_PERIOD;

export interface ValidateShowsFrequencyCustomPeriod {
    type: VALIDATE_SHOWS_FREQUENCY_CUSTOM_PERIOD;
    editorId: string;
}

export function validateShowsFrequencyCustomPeriod(editorId: string): ValidateShowsFrequencyCustomPeriod {
    return {
        type: VALIDATE_SHOWS_FREQUENCY_CUSTOM_PERIOD,
        editorId
    };
}

export type ShowsFrequencyActions =
    | ToggleShowsFrequency
    | ChangeShowsFrequencyLimit
    | ChangeShowsFrequencyPeriodPreset
    | ChangeShowsFrequencyCustomPeriod
    | ValidateShowsFrequencyLimit
    | ValidateShowsFrequencyCustomPeriod
    | InitShowsFrequencyEditors;
